module["exports"] = ["Suisse"];